<script>
import { money } from "../../../../core/forms/money";
import { TicketsPurchase } from "../../controllers/tickets.purchase";
import Form from "../../../../core/forms/form";
import { validity } from "../../../../core/forms/validity";

export default {
    name: "PurchaseTickets",
    mixins: [money, TicketsPurchase, validity],
    components: {
        PhoneInput: () => import('./../../../../components/custom/phone-input.vue')
    },

    computed: {
        cleanFeatures() {
            let features = this.parseStoredData(this.ticketType.features, []);
            // Check if features is empty or contains only a null/empty value.
            if (!features || features.length === 0 ||
                (features.length === 1 && (!features[0] || features[0].toLowerCase() === "null"))) {
                return [
                    'Ticket is non-refundable/exchangeable should you miss the event.',
                    'Ticket cannot be replaced if lost or stolen or damaged.',
                    'Ticket Expires after the day of the event.',
                    'Delivery via SMS and/or email.'
                ];
            }
            return features;
        },
        cleanInstructions() {
            let instructions = this.parseStoredData(this.ticketType.instructions, []);
            if (!instructions || instructions.length === 0 ||
                (instructions.length === 1 && (!instructions[0] || instructions[0].toLowerCase() === "null"))) {
                return [
                    'On the day of the event present your QR code at the entrance. Your ticket will be scanned for access.'
                ];
            }
            return instructions;
        }
    },
    methods: {

        parseStoredData(data, defaults) {
            if (!data) return defaults;
            try {
                if (Array.isArray(data)) {
                    return data.map(item => {
                        if (typeof item === 'string') {
                            return item.replace(/^\[|\]$/g, '').replace(/^"|"$/g, '');
                        }
                        return item;
                    });
                }
                if (typeof data === 'string') {
                    let cleanString = data.replace(/\\"/g, '"');
                    cleanString = cleanString.replace(/^\[|\]$/g, '').replace(/^"|"$/g, '');
                    
                    try {
                        const parsed = JSON.parse(cleanString);
                        if (Array.isArray(parsed)) {
                            return parsed.map(item => {
                                if (typeof item === 'string') {
                                    return item.replace(/^\[|\]$/g, '').replace(/^"|"$/g, '');
                                }
                                return item;
                            });
                        }
                        return [parsed];
                    } catch (e) {
                        return [cleanString];
                    }
                }
                return defaults;
            } catch (e) {
                console.error('Error parsing stored data:', e);
                return defaults;
            }
        }
    }

};
</script>


<template>
    <div id="content" class="bg-light-1 py-4">
        <div class="container">
            <div class="d-flex">
                <div v-if="showPreviewBanner" class="preview-banner">
                    <i class="fas fa-eye mr-2"></i> This is a preview of your event. It's not visible to the public yet.
                </div>
                <div class="flex-grow-1">
                    <h2 class="title-blog text-7">{{ ticket.name }}</h2>
                    <p class="text-1">{{ ticket.description }}</p>
                    <p class="text-1">
                        {{ ticket.category }} &bull;
                        {{ ticket.venue || 'Venue' }} &bull;
                        {{ ticket.event_at || 'Date' }} &bull;
                        {{ ticket.time || 'Time' }}
                    </p>
                </div>
                <div class="w-25 d-none d-lg-block">
                    <img class="rounded-lg shadow-md" style="width: 100%; object-fit: cover; aspect-ratio: 5/2"
                         :src="ticket.image"
                         alt="">
                </div>
            </div>
            <hr class="my-4">

            <!-- Loader -->
            <div v-if="tickets.loading"
                 class="text-center text-primary text-20 line-height-07 mb-5 mt-5 d-flex justify-content-center align-items-center">
                <div class="loader"></div>
            </div>

            <!-- Paid Event -->
            <div v-if="ticket.event_type === 'PAID'">
                <div v-if="ticket.types && ticket.types.length" class="row">
                    <div class="col-lg-5">
                        <!-- Ticket Image -->
                        <img :src="ticketType.image || ticket.image" alt="Event Image"
                             class="rounded-lg shadow-sm mb-3"
                             style="width: 100%; object-fit: cover;">
                        <div class="p-3 bg-white rounded shadow-sm mb-3">
                            <h6 >Select Ticket Type:</h6><hr>
                            <h5>{{ ticketType.name }}</h5>
                            <p>{{ ticketType.description }}</p>
                            <hr>
                            <div class="d-flex flex-wrap mb-3">
                                <button class="btn mb-1 mx-1 btn-sm shadow-none rounded-pill"
                                        v-for="(type, index) in ticket.types"
                                        :key="'type'+index"
                                        :class="[ticketType.id === type.id ? 'btn-primary': 'btn-outline-primary']"
                                        @click="change(type.id)">
                                    <i class="fa fa-check-circle mr-1" v-if="ticketType.id === type.id"></i>
                                    <small class="font-weight-bold">{{ type.name }} ${{ money(type.usd_price) }}</small>
                                    <span v-if="type.is_sold_out" class="badge bg-danger text-white rounded-pill ml-2 p-2">SOLD OUT</span>
                                </button>
                            </div>
                        </div>
                        <div class="p-3 bg-white rounded shadow-sm">
                            <!-- Features Section -->
                            <!-- Features Section -->
                            <div class="mb-4">
                                <h4 class="text-5 fw-400">Features</h4>
                                <ul class="list-group list-group-flush">
                                    <li class="list-group-item px-0" v-for="(feature, index) in cleanFeatures" :key="'feature-'+index">
                                        &bull; {{ feature }}
                                    </li>
                                </ul>
                            </div>

                            <!-- Instructions Section -->
                            <div class="mb-4">
                                <h4 class="text-5 fw-400">Instructions</h4>
                                <hr>
                                <ul class="list-group list-group-flush">
                                    <li class="list-group-item px-0 border-0 py-1" v-for="(instruction, index) in cleanInstructions" :key="'instruction-'+index">
                                        &bull; {{ instruction }}
                                    </li>
                                </ul>
                            </div>
                        </div>
                        </div>

                        <div class="col-lg-7">
                        <div class="blog-post card shadow-sm border-0 mb-4">
                            <div class="pt-4 pb-0 px-4">
                                <h5 class="mb-0">Purchase Ticket</h5>
                            </div>
                            <hr>
                          
                            <!-- Sold Out Alert -->
                            <div v-if="ticketType.is_sold_out" class="alert alert-danger mx-4 my-3">
                                <i class="fa fa-exclamation-circle mr-2"></i>
                                <strong>{{ ticketType.name }}</strong> - SOLD OUT
                            </div>
                            <!-- Purchase Form -->
                            <form ref="form" v-on="formEvents">
                                <div class="px-4 py-2">
                                    <!-- Name and Surname Fields -->
                                    <div class="row">
                                        <div class="col-md-6">
                                            <div class="form-group">
                                                <label for="name" class="form-label">Name</label>
                                                <div class="input-group">
                                                    <div class="input-group-prepend">
                                                        <span class="input-group-text input-icon">
                                                            <i class="fa fa-user"></i>
                                                        </span>
                                                    </div>
                                                    <input type="text" v-model="form.name" required
                                                           :class="['form-control', form.errors.get('name') ? 'is-invalid' : '']"
                                                           placeholder="Your Name">
                                                </div>
                                                <div v-text="form.errors.get('name')" class="invalid-feedback"/>
                                            </div>
                                        </div>
                                        <div class="col-md-6">
                                            <div class="form-group">
                                                <label for="surname" class="form-label">Surname</label>
                                                <div class="input-group">
                                                    <div class="input-group-prepend">
                                                        <span class="input-group-text input-icon">
                                                            <i class="fa fa-user"></i>
                                                        </span>
                                                    </div>
                                                    <input type="text" v-model="form.surname" required
                                                           :class="['form-control', form.errors.get('surname') ? 'is-invalid' : '']"
                                                           placeholder="Your Surname">
                                                </div>
                                                <div v-text="form.errors.get('surname')" class="invalid-feedback"/>
                                            </div>
                                        </div>
                                    </div>

                                    <div class="form-group">
                                        <label for="quantity" class="form-label">How many tickets?</label>
                                        <input v-model="form.quantity" type="text" class="form-control" id="quantity"
                                               required aria-describedby="quantity" placeholder="Quantity">
                                        <div v-text="form.errors.get('quantity')" class="text-danger"/>
                                    </div>

                                    <div class="form-group">
                                        <label>Pay with</label>
                                        <div class="input-group">
                                            <div class="input-group-prepend">
                                                <span class="input-group-text input-icon">
                                                    <i class="fa fa-credit-card"></i>
                                                </span>
                                            </div>
                                            <select v-model="form.payment" :disabled="form.currency === 'USD'"
                                                    :class="[ 'custom-select' , form.errors.get('payment') ? 'is-invalid' : '' ]">
                                                <option value="ecocash-usd">EcoCash (USD)</option>
                                                <option value="stripe">International Card</option>
                                            </select>
                                        </div>
                                        <div v-text="form.errors.get('payment')" class="invalid-feedback"/>
                                    </div>
                                    <div class="form-group" v-if="form.payment === 'ecocash' || form.payment === 'ecocash-usd'">
                                        <label>EcoCash Phone Number</label>
                                        <phone-input v-model="form.ecocash" :countries="['ZW']"></phone-input>
                                        <div v-text="form.errors.get('ecocash')" class="text-danger"/>
                                    </div>
                                    <div class="form-group">
                                        <label>Delivery Phone Number</label>
                                        <phone-input v-model="form.phone"></phone-input>
                                        <div v-text="form.errors.get('phone')" class="text-danger"/>
                                        <small>* Also used for notifications</small>
                                    </div>
                                    <div class="form-group">
                                        <label for="email" class="form-label">Delivery Email</label>
                                        <div class="input-group">
                                            <div class="input-group-prepend">
                                                <span class="input-group-text input-icon">
                                                    <i class="fa fa-envelope"></i>
                                                </span>
                                            </div>
                                            <input type="email" v-model="form.email" value="email" required
                                                   :class="['form-control', form.errors.get('email') ? 'is-invalid' : '']"
                                                   placeholder="Email">
                                            <div v-text="form.errors.get('email')" class="invalid-feedback"/>
                                        </div>
                                    </div>
                                    <div class="form-group">
                                        <div class="d-flex align-items-center">
                                            <input type="checkbox" class="mr-2" id="checkterms" v-model="termsAccepted">
                                            <label class="mb-0" for="checkterms">
                                                I accept the <a target="_blank" href="/terms">Terms & Conditions</a>
                                            </label>
                                        </div>
                                    </div>
                                </div>
                            </form>
                            <div class="alert alert-success text-center border rounded mx-4 mb-3">
                                <i class="fa fa-info-circle"></i>
                                <strong>Paying {{ form.payment === 'ecocash' ? 'ZWG' : 'USD' }} {{ ticketTotal }}</strong>
                            </div>
                              <!-- Error Alert -->
                              <div v-if="errorMessage" class="alert alert-danger mx-4 my-3">
                                <i class="fa fa-exclamation-circle mr-2"></i>
                                {{ errorMessage }}
                            </div>
                            <div class="form-group px-4">
                                <button type="button"
                                        v-bind="buttonValidity"
                                        :class="{ 'btn-loading': form.loading, ...buttonValidity.class }"
                                        @click="formVisibility ? submit() : (formVisibility = true)">
                                    Purchase Ticket
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
                <div v-else class="p-5 text-center">
                    No tickets available for this event
                </div>
            </div>

            <!-- Free Event -->
            <div v-else-if="ticket.event_type === 'FREE'" class="p-5 text-center">
                <h4 class="text-primary">This event is free to attend!</h4>
                <p>No ticket purchase is required. Just show up and enjoy!</p>
                <div class="mt-4">
                    <img :src="ticket.image || defaultImage" alt="Event Image"
                         class="rounded-lg shadow-lg"
                         style="width: 100%; max-width: 500px;">
                </div>
                <div class="mt-4">
                    <h5 class="text-5">Event Details:</h5>
                    <p><strong>Date:</strong> {{ ticket.event_at || 'TBD' }}</p>
                    <p><strong>Time:</strong> {{ ticket.time || 'TBD' }}</p>
                    <p><strong>Venue:</strong> {{ ticket.venue || 'Venue information coming soon' }}</p>
                </div>
            </div>
        </div>
    </div>
</template>
